module.exports = __webpack_public_path__ + "img/page9img8.6e5b3da5.png";